<div class="shimmer-container">
  <div class="shimmer-image"></div>
  <div class="shimmer-title"></div>
  <div class="shimmer-price"></div>
  <div class="shimmer-description"></div>
</div>

